var map = {
	"./10-12-2020-v2/1024/img/Tail_feathers_DiffuseColor.png": "0e5a",
	"./10-12-2020-v2/2048/img/Tail_feathers_DiffuseColor.png": "52c1",
	"./10-12-2020-v2/512/img/Tail_feathers_DiffuseColor.png": "0402",
	"./10-12-2020-v3/1024/img/Tail_feathers_DiffuseColor.png": "bb0c",
	"./10-12-2020-v3/2048/img/Tail_feathers_DiffuseColor.png": "9540",
	"./10-12-2020-v3/512/img/Tail_feathers_DiffuseColor.png": "dcf3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc05";